import Vue from 'vue';
import App from './App.vue';

Vue.config.productionTip = false;

const spConfig = {
  // clientSecret: 'PkkJXNRpO2l0r5u6u0PlCNme1KA8akGejMIjHI5Gkj8',
  // clientId: 'c3sbrpbtkbs5gverurfkxpemc',
  authHeader: 'SPC:h1QTpkiGyASgEUomZ9Cx3A:q0WFxvLOWC01ri8oZ1co3MTZPJg',
  clientLocationId: 'bestia',
  menuName: 'Dinner',
  showFootnotes: false
};

const mountMenuElement = (menuElem) => {
  if (!menuElem || menuElem.nodeType !== 1) return;
  if (!menuElem.matches || !menuElem.matches('[data-sp-menu-name]')) return;

  new Vue({
    render: h =>
      h(App, {
        props: {
          ...spConfig,
          menuName: menuElem.getAttribute('data-sp-menu-name'),
          sectionName: menuElem.getAttribute('data-sp-section-name'),
        }
      })
  }).$mount(menuElem);
};

const initializeSinglePlatformMenus = () => {
  // Mount any placeholders present at init time
  [...document.querySelectorAll('[data-sp-menu-name]')].forEach(mountMenuElement);

  // Also watch for blocks that are injected later (lazy-loaded sections, editor output)
  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach(node => {
          if (node.nodeType !== 1) return;
          // If the added node is a placeholder, mount it; otherwise check its descendants
          if (node.matches && node.matches('[data-sp-menu-name]')) {
            mountMenuElement(node);
          } else if (node.querySelectorAll) {
            node.querySelectorAll('[data-sp-menu-name]').forEach(mountMenuElement);
          }
        });
      }
    });
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeSinglePlatformMenus);
} else {
  // If DOM is already ready (e.g., script loaded late), initialize immediately
  initializeSinglePlatformMenus();
}
